/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_file_xls': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M-2-2h24v24H-2z"/><path pid="1" d="M0 0h20v20H0V0zm12.135 14.824c.08.123.112.176.208.176h1.498c.095 0 .159-.07.159-.176l-3.076-4.842L14 5.176C14 5.07 13.936 5 13.84 5h-1.497c-.096 0-.128.053-.208.176L10 8.504 7.865 5.176C7.785 5.053 7.753 5 7.657 5H6.16C6.064 5 6 5.07 6 5.176l3.076 4.806L6 14.824c0 .106.064.176.16.176h1.497c.096 0 .128-.053.208-.176L10 11.479l2.135 3.345z" _fill="#1A6D40"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_file_xls.js